
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/affiliate-partner-program",
      function () {
        return require("private-next-pages/affiliate-partner-program.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/affiliate-partner-program"])
      });
    }
  